<script lang="ts">
  import page from "page";
  import { currentUser, isAdmin, isSuperAdmin } from "../stores/store";
  import { onMount } from "svelte";

  export let projectId;
  const currentHref = page.current;

  const tabs = [];

  tabs.push({ label: "Project Details", href: `/projects/${projectId}` });

  tabs.push({
    label: "Participants",
    href: `/projects/${projectId}/participants`,
  });
  if ($isAdmin) {
    tabs.push({
      label: "Facilitators",
      href: `/projects/${projectId}/facilitators`,
    });
  }
  // if ($isAdmin) {
  tabs.push({ label: "Data Cleanup", href: `/projects/${projectId}/cleanup` });
  // }

  tabs.push({ label: "Invites", href: `/projects/${projectId}/invites` });
  if ($isSuperAdmin) {
    tabs.push({
      label: "Question set",
      href: `/projects/${projectId}/questions`,
    });
  }

  if ($isSuperAdmin) {
    tabs.push({
      label: "Question set editor",
      href: `/projects/${projectId}/questionset-editor`,
    });
  }

  //only works for understory
  /*tabs.push({ label: "Stats", href: `/projects/${projectId}/stats` });
  if ($isAdmin) {
    tabs.push({ label: "Compare", href: `/projects/${projectId}/compare` });
  }*/

  tabs.push({ label: "Gallery", href: `/projects/${projectId}/Gallery` });

  // Responsive logic
  let tabsContainer;
  let showDropdown = false;
  let visibleTabs = tabs;
  let hiddenTabs = [];
  let isCalculating = false;

  function updateVisibleTabs() {
    if (!tabsContainer || isCalculating) return;
    
    isCalculating = true;
    
    // Use requestAnimationFrame to avoid layout thrashing
    requestAnimationFrame(() => {
      const containerWidth = tabsContainer.offsetWidth;
      const dropdownToggleWidth = 80; // Reduced estimate for "More ▼"
      
      // Start showing dropdown earlier - at 1200px instead of waiting for overflow
      if (containerWidth < 1500) {
        // Show fewer tabs on smaller screens
        let maxTabs;
        if (containerWidth < 600) maxTabs = 1;
        else if (containerWidth < 800) maxTabs = 3;
        else if (containerWidth < 1000) maxTabs = 4;
        else if (containerWidth < 1200) maxTabs = 5;
        else if (containerWidth < 1500) maxTabs = 8
        else maxTabs = tabs.length;
        
        if (maxTabs < tabs.length) {
          visibleTabs = tabs.slice(0, maxTabs);
          hiddenTabs = tabs.slice(maxTabs);
        } else {
          visibleTabs = tabs;
          hiddenTabs = [];
        }
      } else {
        // On larger screens, calculate based on actual width
        const tabElements = tabsContainer.querySelectorAll('.tab:not(.dropdown-toggle)');
        let totalWidth = 0;
        let cutoffIndex = tabs.length;
        
        for (let i = 0; i < tabElements.length; i++) {
          const tabWidth = tabElements[i].offsetWidth + 20; // Include margin
          if (totalWidth + tabWidth + dropdownToggleWidth > containerWidth && i > 1) {
            cutoffIndex = i;
            break;
          }
          totalWidth += tabWidth;
        }
        
        visibleTabs = tabs.slice(0, cutoffIndex);
        hiddenTabs = tabs.slice(cutoffIndex);
      }
      
      isCalculating = false;
    });
  }

  let resizeTimeout;
  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateVisibleTabs, 100); // Debounce resize
  }

  onMount(() => {
    updateVisibleTabs();
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimeout);
    };
  });

  function toggleDropdown() {
    showDropdown = !showDropdown;
  }

  function closeDropdown() {
    showDropdown = false;
  }
</script>

<svelte:window on:click={closeDropdown} />

<div class="tabs" bind:this={tabsContainer}>
  {#each visibleTabs as tab}
    <a href={tab.href} class="tab" class:is-active={currentHref == tab.href}>
      {tab.label}
    </a>
  {/each}
  
  {#if hiddenTabs.length > 0}
    <div class="dropdown-container">
      <button 
        class="tab dropdown-toggle" 
        class:is-active={hiddenTabs.some(tab => currentHref === tab.href)}
        on:click|stopPropagation={toggleDropdown}
      >
        More ▼
      </button>
      
      {#if showDropdown}
        <div class="dropdown-menu">
          {#each hiddenTabs as tab}
            <a 
              href={tab.href} 
              class="dropdown-item" 
              class:is-active={currentHref == tab.href}
              on:click={closeDropdown}
            >
              {tab.label}
            </a>
          {/each}
        </div>
      {/if}
    </div>
  {/if}
</div>



<style lang="scss">
  .tabs {
    display: flex;
    padding-left: 8px;
    position: relative;
   /* overflow: hidden;*/
    
    a {
      color: inherit;
      text-decoration: none;
      display: inline-block;
    }
    
    li,
    .tab {
      font-weight: bold;
      background: #e3e2d3;
      line-height: 2rem;
      padding: 0 12px;
      position: relative;
      margin-right: 20px;
      cursor: pointer;
      filter: drop-shadow(0px -1px 0px #d4d3bc);
      
      &:before,
      &:after {
        content: "";
        position: absolute;
        display: inline-block;
        margin-top: 0;
        width: 0;
        height: 0;
        right: 0;
        top: 0;
        border-style: solid;
        border-width: 32px 0 0 32px;
        transform: translate(100%, 0);
        border-color: transparent transparent transparent #e3e2d3;
      }
      
      &:before {
        border-width: 0 0 32px 8px;
        transform: translate(-100%, 0);
        right: auto;
        left: 0;
        border-color: transparent transparent #e3e2d3 transparent;
      }
      
      &.is-active {
        background: #d4d3bc;
        z-index: 12 !important;
        
        &:before {
          border-color: transparent transparent #d4d3bc transparent;
        }
        
        &:after {
          border-color: transparent transparent transparent #d4d3bc;
        }
      }
      
      &:nth-child(1) { z-index: 10; }
      &:nth-child(2) { z-index: 9; }
      &:nth-child(3) { z-index: 8; }
      &:nth-child(4) { z-index: 7; }
      &:nth-child(5) { z-index: 6; }
      &:nth-child(6) { z-index: 5; }
      &:nth-child(7) { z-index: 4; }
      &:nth-child(8) { z-index: 3; }
    }
  }

  .dropdown-container {
    position: relative;
  }

  .dropdown-toggle {
    font-weight: bold;
    background: #e3e2d3;
    line-height: 2rem;
    padding: 0 12px;
    position: relative;
    margin-right: 20px;
    cursor: pointer;
    filter: drop-shadow(0px -1px 0px #d4d3bc);
    border: none;
    z-index: 2;
    
    &:before,
    &:after {
      content: "";
      position: absolute;
      display: inline-block;
      margin-top: 0;
      width: 0;
      height: 0;
      right: 0;
      top: 0;
      border-style: solid;
      border-width: 32px 0 0 32px;
      transform: translate(100%, 0);
      border-color: transparent transparent transparent #e3e2d3;
    }
    
    &:before {
      border-width: 0 0 32px 8px;
      transform: translate(-100%, 0);
      right: auto;
      left: 0;
      border-color: transparent transparent#e3e2d3 transparent;
    }
    
    &.is-active {
      background: #d4d3bc;
      z-index: 12 !important;
      
      &:before {
        border-color: transparent transparent #d4d3bc transparent;
      }
      
      &:after {
        border-color: transparent transparent transparent #d4d3bc;
      }
    }
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #d4d3bc;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: 200px;
    max-height: 300px;
    overflow-y: auto;
    margin-top: 4px;
  }

  .dropdown-item {
    display: block;
    padding: 8px 16px;
    text-decoration: none;
    color: inherit;
    font-weight: bold;
    transition: background-color 0.2s ease;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    width:100%;
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background-color: #e3e2d3;
    }
    
    &.is-active {
      background-color: #d4d3bc;
    }
  }
</style>